import * as React from "react";
import {InputHTMLAttributes} from "react";
import {Field} from 'redux-form'
import IFormInputs from "./IFormInputs";
import {FormattedMessage} from "react-intl";
import InputRenderer from "../formrenderers/InputRenderer";
import Email from "../validations/Email";
import Required from "../validations/Required";

export interface IEmailProps extends IFormInputs, InputHTMLAttributes<HTMLInputElement> {
    isRequired?: boolean
}

export default (props: IEmailProps) => {
    const { inputID, label = <FormattedMessage id="form.email" />,
        validationDisabled = false,
        isRequired = true,
        ...rest
    } = props;


    const validations = (() => {
        if(validationDisabled) {
            return undefined;
        }

        const validations = [Email];
        if(isRequired) {
            validations.push(Required);
        }
        return validations;
    })();

    return (
        <Field name={inputID} label={label} type="text" component={InputRenderer} validate={validations} {...rest} />
    );
}